import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { postCliente } from "../helpers/rutaClientes";

const estadoInicial = {
  apellido1: "",
  apellido2: "",
  nombre: "",
  dni: "",
  fecing: "",
  telefono1: "",
  email: "",

  domicilio: "",
  direccion2: "",
  ciudad: "",
  estado: "",
  zipCode: "",
  pais: "USA",

  activo: true,
};

const clean = (v) => String(v ?? "").trim();

const AddClienteForm = () => {
  const history = useHistory();

  const [formValues, setFormValues] = useState(estadoInicial);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");
  const [ok, setOk] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormValues((prev) => ({
      ...prev,
      [name]: name === "estado" ? String(value || "").toUpperCase() : value,
    }));
  };

  const validar = () => {
    const apellido1 = clean(formValues.apellido1);
    const nombre = clean(formValues.nombre);
    const dni = clean(formValues.dni);

    if (!apellido1) return "Completá Apellido 1.";
    if (!nombre) return "Completá Nombre.";
    if (!dni) return "Completá ID / Documento.";

    return "";
  };

  const armarPayload = () => ({
    apellido1: clean(formValues.apellido1),
    apellido2: clean(formValues.apellido2),
    nombre: clean(formValues.nombre),
    dni: clean(formValues.dni),

    fecing: formValues.fecing || null,

    telefono1: clean(formValues.telefono1),
    email: clean(formValues.email),

    domicilio: clean(formValues.domicilio),
    direccion2: clean(formValues.direccion2),
    ciudad: clean(formValues.ciudad),
    estado: clean(formValues.estado).toUpperCase(),
    zipCode: clean(formValues.zipCode),
    pais: clean(formValues.pais) || "USA",

    activo: true,
  });

  const handleSubmit = async (e) => {
    e.preventDefault();

    setError("");
    setOk("");

    const msg = validar();

    if (msg) {
      setError(msg);
      return;
    }

    try {
      setSaving(true);

      await postCliente(armarPayload());

      setOk("Cliente guardado correctamente.");
      setFormValues(estadoInicial);
    } catch (err) {
      console.error("❌ Error guardando cliente:", err);

      setError(
        err?.response?.data?.error ||
          err?.response?.data?.message ||
          err?.message ||
          "No se pudo guardar el cliente."
      );
    } finally {
      setSaving(false);
    }
  };

  const volver = () => {
    history.goBack();
  };

  return (
    <div className="container mt-4 mb-5">
      <div className="card shadow-sm">
        <div className="card-header bg-primary text-white">
          <h5 className="mb-0">Alta de Cliente que Compra</h5>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="card-body">
            {error && (
              <div className="alert alert-danger py-2" role="alert">
                {error}
              </div>
            )}

            {ok && (
              <div className="alert alert-success py-2" role="alert">
                {ok}
              </div>
            )}

            <h6 className="border-bottom pb-2 mb-3">Datos principales</h6>

            <div className="row g-3">
              <div className="col-md-4">
                <label className="form-label">Apellido 1 *</label>
                <input
                  type="text"
                  className="form-control"
                  name="apellido1"
                  value={formValues.apellido1}
                  onChange={handleChange}
                  disabled={saving}
                  autoComplete="off"
                />
              </div>

              <div className="col-md-4">
                <label className="form-label">Apellido 2</label>
                <input
                  type="text"
                  className="form-control"
                  name="apellido2"
                  value={formValues.apellido2}
                  onChange={handleChange}
                  disabled={saving}
                  autoComplete="off"
                />
              </div>

              <div className="col-md-4">
                <label className="form-label">Nombre *</label>
                <input
                  type="text"
                  className="form-control"
                  name="nombre"
                  value={formValues.nombre}
                  onChange={handleChange}
                  disabled={saving}
                  autoComplete="off"
                />
              </div>

              <div className="col-md-4">
                <label className="form-label">ID / Documento *</label>
                <input
                  type="text"
                  className="form-control"
                  name="dni"
                  value={formValues.dni}
                  onChange={handleChange}
                  disabled={saving}
                  autoComplete="off"
                />
              </div>

              <div className="col-md-4">
                <label className="form-label">Fecha de ingreso</label>
                <input
                  type="date"
                  className="form-control"
                  name="fecing"
                  value={formValues.fecing}
                  onChange={handleChange}
                  disabled={saving}
                />
              </div>
            </div>

            <h6 className="border-bottom pb-2 mt-4 mb-3">Contacto</h6>

            <div className="row g-3">
              <div className="col-md-4">
                <label className="form-label">Teléfono</label>
                <input
                  type="text"
                  className="form-control"
                  name="telefono1"
                  value={formValues.telefono1}
                  onChange={handleChange}
                  disabled={saving}
                  autoComplete="off"
                />
              </div>

              <div className="col-md-8">
                <label className="form-label">Email</label>
                <input
                  type="email"
                  className="form-control"
                  name="email"
                  value={formValues.email}
                  onChange={handleChange}
                  disabled={saving}
                  autoComplete="off"
                />
              </div>
            </div>

            <h6 className="border-bottom pb-2 mt-4 mb-3">Dirección USA</h6>

            <div className="row g-3">
              <div className="col-md-8">
                <label className="form-label">Address Line 1</label>
                <input
                  type="text"
                  className="form-control"
                  name="domicilio"
                  value={formValues.domicilio}
                  onChange={handleChange}
                  disabled={saving}
                  autoComplete="off"
                />
              </div>

              <div className="col-md-4">
                <label className="form-label">Apt / Suite / Unit</label>
                <input
                  type="text"
                  className="form-control"
                  name="direccion2"
                  value={formValues.direccion2}
                  onChange={handleChange}
                  disabled={saving}
                  autoComplete="off"
                />
              </div>

              <div className="col-md-4">
                <label className="form-label">Ciudad</label>
                <input
                  type="text"
                  className="form-control"
                  name="ciudad"
                  value={formValues.ciudad}
                  onChange={handleChange}
                  disabled={saving}
                  autoComplete="off"
                />
              </div>

              <div className="col-md-3">
                <label className="form-label">Estado</label>
                <input
                  type="text"
                  className="form-control"
                  name="estado"
                  value={formValues.estado}
                  onChange={handleChange}
                  disabled={saving}
                  maxLength={2}
                  placeholder="FL"
                  autoComplete="off"
                />
              </div>

              <div className="col-md-3">
                <label className="form-label">ZIP Code</label>
                <input
                  type="text"
                  className="form-control"
                  name="zipCode"
                  value={formValues.zipCode}
                  onChange={handleChange}
                  disabled={saving}
                  autoComplete="off"
                />
              </div>

              <div className="col-md-2">
                <label className="form-label">País</label>
                <input
                  type="text"
                  className="form-control"
                  name="pais"
                  value={formValues.pais}
                  onChange={handleChange}
                  disabled={saving}
                  autoComplete="off"
                />
              </div>
            </div>
          </div>

          <div className="card-footer d-flex justify-content-end gap-2">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={volver}
              disabled={saving}
            >
              Volver
            </button>

            <button type="submit" className="btn btn-primary" disabled={saving}>
              {saving ? "Guardando..." : "Guardar Cliente"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddClienteForm;